"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _OrthographicCameraApi_camera, _OrthographicCameraApi_inputValidator, _OrthographicCameraApi_logger, _OrthographicCameraApi_viewportApi;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrthographicCameraApi = void 0;
const viewer_rendering_engine_camera_engine_1 = require("@shapediver/viewer.rendering-engine.camera-engine");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const AbstractCameraApi_1 = require("./AbstractCameraApi");
class OrthographicCameraApi extends AbstractCameraApi_1.AbstractCameraApi {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor(viewportApi, camera) {
        super(viewportApi, camera);
        // #region Properties (4)
        _OrthographicCameraApi_camera.set(this, void 0);
        _OrthographicCameraApi_inputValidator.set(this, viewer_shared_services_1.InputValidator.instance);
        _OrthographicCameraApi_logger.set(this, viewer_shared_services_1.Logger.instance);
        _OrthographicCameraApi_viewportApi.set(this, void 0);
        __classPrivateFieldSet(this, _OrthographicCameraApi_viewportApi, viewportApi, "f");
        __classPrivateFieldSet(this, _OrthographicCameraApi_camera, camera, "f");
        this.scope = "OrthographicCameraApi";
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (2)
    get direction() {
        return __classPrivateFieldGet(this, _OrthographicCameraApi_camera, "f").direction;
    }
    set direction(value) {
        const scope = "direction";
        __classPrivateFieldGet(this, _OrthographicCameraApi_inputValidator, "f").validateAndError(`${this.scope}.${scope}`, value, "enum", true, Object.values(viewer_rendering_engine_camera_engine_1.ORTHOGRAPHIC_CAMERA_DIRECTION));
        __classPrivateFieldGet(this, _OrthographicCameraApi_camera, "f").direction = value;
        __classPrivateFieldGet(this, _OrthographicCameraApi_logger, "f").debug(`${this.scope}.${scope}: ${scope} was set to: ${value}`);
        __classPrivateFieldGet(this, _OrthographicCameraApi_viewportApi, "f").update();
    }
}
exports.OrthographicCameraApi = OrthographicCameraApi;
_OrthographicCameraApi_camera = new WeakMap(), _OrthographicCameraApi_inputValidator = new WeakMap(), _OrthographicCameraApi_logger = new WeakMap(), _OrthographicCameraApi_viewportApi = new WeakMap();
//# sourceMappingURL=OrthographicCameraApi.js.map